import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_GENERIC_ACCOUNTS = createAsyncActionTypes('FETCH_GENERIC_ACCOUNTS');